var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackingVocalsStem = function SvgBackingVocalsStem(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.657 18.33a.63.63 0 0 1-.862-.028L1.963 16.47a.63.63 0 0 1-.028-.863l8.3-9.487a4.086 4.086 0 1 1 3.909 3.909zm-.387-1.339-.996-.997 7.32-8.365c.197.437.475.847.835 1.207s.77.638 1.207.835zm8.052-9.048a2.823 2.823 0 1 0 3.992-3.993 2.823 2.823 0 0 0-3.992 3.993",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.878 14.074a.63.63 0 0 1 .038.892l-3.311 3.613a.63.63 0 0 1-.93 0l-1.506-1.642a.631.631 0 0 1 .93-.853l1.04 1.134 2.847-3.105a.63.63 0 0 1 .892-.039"
  })));
};
export default SvgBackingVocalsStem;